import { Component, Input, LOCALE_ID, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, UntypedFormBuilder, UntypedFormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { Subject, SubscriptionLike } from 'rxjs';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { LookUp } from 'src/app/services/administration/administration-summary.service';
import { EmailConfigurationService } from 'src/app/services/administration/EmailConfigurationService';
import { CommonService } from 'src/app/services/common.service';
import { SmtpConfigurationService } from 'src/app/services/common/SmtpConfigurationService';
import { FileData, FileService } from 'src/app/services/file.service';
import { EmailtestconnectionComponent } from '../emailtestconnection/emailtestconnection.component';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-email-account',
  templateUrl: './email-account.component.html',
  styleUrls: ['./email-account.component.scss']
})
export class EmailAccountComponent implements OnInit {
  ACCOUNT_TYPE: string = "EMAIL_ACCOUNT_TYPE";
  Config: FormGroup;
  formSubmitted = false;
  mode: string = "Add";
  @Input() public Content: any;
  accountTypes: LookUp[];
  TypeCode?: string;
  //content:any;
  fileToUpload: File | null;
  fileName: string = '';
  emailPattern = "^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$";
  isFormPristine = true;
  action: Subject<any> = new Subject();
  handleFilePristine: boolean = false
  emailtypelist: any[] = [];
  heading:any;
  resdata:any;

  private subfetchConfigAsync?: SubscriptionLike;
  private subinsertConfigAsync?: SubscriptionLike;
  private subupdateConfigAsync?: SubscriptionLike;
  private subvalueChanges?: SubscriptionLike;
  private subGetLookUpsAsync?: SubscriptionLike;
  private subUploadFile?: SubscriptionLike;
  private subImapTestAsync?: SubscriptionLike;

  constructor(
    private fb: FormBuilder,
    public modalRef: NgbActiveModal,
    private modalService: NgbModal,
    private commonservice: CommonService,
    private readonly emailService: EmailConfigurationService,
    private readonly smtpService: SmtpConfigurationService,

  ) { }

  ngOnDestroy(): void {
    if (this.subfetchConfigAsync)
      this.subfetchConfigAsync.unsubscribe();
    if (this.subinsertConfigAsync)
      this.subinsertConfigAsync.unsubscribe();
    if (this.subupdateConfigAsync)
      this.subupdateConfigAsync.unsubscribe();
    if (this.subvalueChanges)
      this.subvalueChanges.unsubscribe();
    if (this.subGetLookUpsAsync)
      this.subGetLookUpsAsync.unsubscribe();
    if (this.subUploadFile)
      this.subUploadFile.unsubscribe();
    if (this.subImapTestAsync)
      this.subImapTestAsync.unsubscribe();
  }


  ngOnInit(): void {
    this.emailtypelist.push({
      label: "Select",
      value: "-1",
      checked: true

    });

    this.emailtypelist.push({
      label: "Google (G Suite/Gmail)",
      value: 'GOOGLE'
    });

    this.emailtypelist.push({
      label: "Microsoft (Office 365)-Advanced",
      value: 'MICROSOFT'
    });

    this.emailtypelist.push({
      label: "Microsoft (Office 365)-Graph API",
      value: 'GRAPHAPI'
    });


    if (this.Content.content != undefined || this.Content.content != null)
      this.mode = this.Content.content.OperationType;
    this.buildForm();
    this.setAccountTypeValidators();
    this.fetchEmailConfig();
  }

  buildForm() {
    this.Config = this.fb.group({
      EmailServerID: [null],
      EmailID: [null, [Validators.required, Validators.maxLength(100)]],
      EmailPwd: [null, [Validators.required, Validators.maxLength(25)]],
      EmailDisplayName: [null, [Validators.maxLength(100)]],
      EmailAccountTypeID: [null, [Validators.required]],
      EmailAccountType: [null, []],
      EmailAccountTypeCode: ["-1", []],
      TempFileID: [null, [Validators.required]],
      GSuiteFileID: [null, [Validators.required]],
      FileName: [null, []],
      FileExt: [null, []],
      MicrosoftTenantID: [null, [Validators.maxLength(1000)]],
      MicrosoftClientID: [null, [Validators.maxLength(1000)]],
      MicrosoftClientSecret: [null, [Validators.maxLength(1000)]],
      SMTPHost: [null, [Validators.required, Validators.maxLength(250)]],
      SMTPPort: [null, [Validators.required, Validators.maxLength(5)]],
      SMTPSSL: [null, []],
      UserID: [null, []],
      SentItemsFolderName: [null, []],
      IMAPHost: [null, [Validators.required, Validators.maxLength(250)]],
      IMAPPort: [null, [Validators.required, Validators.maxLength(5)]],
      IMAPSSL: [null, []],
      EmailServerStatus: [null, []],
      OrgID: [null, []],
      LoggedUserID: [null, []],
      OrgGroupID: [null, []],
      ManageAccessToken:[false],
      ManageUserEmailID:[null, [Validators.maxLength(100)]],
      ManagerUserPassword:[null, [Validators.maxLength(100)]],
      GraphApiRead:[false],
      GraphApiSend:[false]
    });
  }

  setAccountTypeValidators() {
     
    const typeCode = this.Config.get('EmailAccountTypeCode');
    const tempFileID = this.Config.get('TempFileID');
    const gSuiteFileID = this.Config.get('GSuiteFileID');
    const microsoftTenantID = this.Config.get('MicrosoftTenantID');
    const microsoftClientID = this.Config.get('MicrosoftClientID');
    const microsoftClientSecret = this.Config.get('MicrosoftClientSecret');
    const ManageAccessToken =this.Config.get('ManageAccessToken');
    const manageUserEmailID =this.Config.get('ManageUserEmailID');
    const ManagerUserPassword=this.Config.get('ManagerUserPassword');   
    var type = this.Config.get('EmailAccountTypeCode')?.value;
    if (type) {
       
      if (type === "GOOGLE") {
        tempFileID?.setValidators([Validators.required]);
        gSuiteFileID?.setValidators([Validators.required]);
        microsoftTenantID?.setValidators(null);
        microsoftClientID?.setValidators(null);
        microsoftClientSecret?.setValidators(null);        
      }

      if (type === "MICROSOFT" || type === "GRAPHAPI") {
        tempFileID?.setValidators(null);
        gSuiteFileID?.setValidators(null);
        microsoftTenantID?.setValidators([Validators.required, Validators.maxLength(1000)]);
        microsoftClientID?.setValidators([Validators.required, Validators.maxLength(1000)]);
        microsoftClientSecret?.setValidators([Validators.required, Validators.maxLength(1000)]);

      }
    }

    typeCode?.updateValueAndValidity();
    tempFileID?.updateValueAndValidity();
    gSuiteFileID?.updateValueAndValidity();
    microsoftTenantID?.updateValueAndValidity();
    microsoftClientID?.updateValueAndValidity();
    microsoftClientSecret?.updateValueAndValidity();
    ManageAccessToken?.updateValueAndValidity();
  }
  IsAccessToken(event){
    if(event==true){
      this.Config.controls["ManageAccessToken"].value;
    }
    if(event==false){
      this.Config.get('ManageUserEmailID')?.setValue(null);
      this.Config.get('ManagerUserPassword')?.setValue(null);
    }
  }
  fetchEmailConfig() {
    if (this.Content.content !== undefined && this.Content.content !== null) {
      if (this.Content.content.ID !== undefined && this.Content.content.ID !== null) {
        this.subfetchConfigAsync = this.emailService.fetchConfigAsync(this.Content.content.ID).subscribe(res => {
          if (res) {
            this.TypeCode = res.EmailAccountTypeCode;
            this.resdata=res;
            this.resdata.ManageAccessToken=this.resdata.ManageAccessToken==1?true:false;
            this.Config.patchValue(this.resdata);
              if (res.FileName && res.FileExt)
              this.fileName = res.FileName + res.FileExt;
              let  type = this.Config.get('EmailAccountTypeCode')?.value;
              if (type != 'GOOGLE') {
                this.fileName=""
                 }
            if (this.Content.content.OperationType === "View") {
              this.Config.disable();
            }
            this.IsManageAccessToken( this.resdata);
          }
        });
      }
    }
  }
  IsManageAccessToken(event){
    if(event.ManageAccessToken==true){
      this.Config.controls["ManageAccessToken"].setValue(true);
      this.Config.get('ManageUserEmailID')?.setValue(event.ManageUserEmailID);
      this.Config.get('ManagerUserPassword')?.setValue(event.ManagerUserPassword);
    }
    if(event==false){
      this.Config.controls["ManageAccessToken"].setValue(false);
      this.Config.controls['ManageUserEmailID'].setValue(null);
      this.Config.controls['ManagerUserPassword'].setValue(null);
    }
  }
  Save() {
     
    if (this.ValidateForm()) {
      if (this.Content.content.OperationType === 'Add') {
        this.createConfig();
      }
      if (this.Content.content.OperationType === 'Edit') {
        this.updateConfig();
      }
    }
  }

  createConfig() {
     
    const formdata= this.Config.value;
    formdata.ManageAccessToken=formdata.ManageAccessToken==false?0:1;
    this.subinsertConfigAsync = this.emailService.insertConfigAsync(this.Config.value).subscribe(
      result => {
        if (result != null && result != undefined) {
          if (result.Status == 0) {
            this.commonservice.SuccessBanner(result.Message);
            this.modalRef.close('save');
          } else {
            if (result.Message)
            this.commonservice.ValidationBanner(result.Message);
          }
        }
        else {
          this.commonservice.ValidationBanner("Unable to save");
        }
      },
      err => {
        this.commonservice.ValidationBanner(err);
      }
    );
  }

  updateConfig() {
    const formdata= this.Config.value;
    formdata.ManageAccessToken=formdata.ManageAccessToken==false?0:1;
    this.subupdateConfigAsync = this.emailService.updateConfigAsync(this.Config.value).subscribe(
      result => {
        if (result != null && result != undefined) {
          if (result.Status == 0) {
            this.commonservice.SuccessBanner(result.Message);
            this.modalRef.close('save');
          } else {
            if (result.Message)
            this.commonservice.ValidationBanner(result.Message);
          }
        }
        else {
          var err: any = [];
          err.push("Unable to save");
          this.commonservice.ValidationBanner(err);
        }
      },
      err => {
        this.commonservice.ValidationBanner(err);
      }
    );
  }

  ValidateForm() {
     

    let isValid = true;

    if (!this.Config.valid) {
      var err: any = [];

      if (this.Config.get('EmailID')?.errors?.required) {
        err.push("Please enter Email Address</br>");
      }
        let isValidEmail = this.commonservice.validateEmail(this.Config.controls['EmailID'].value);
        if (!isValidEmail && this.Config.controls['EmailID'].value ) {
          err.push("Please enter valid Email Address </br>");
        }

      if (this.Config.get('EmailID')?.errors?.maxLength) {
        err.push("Length of Email Address should not exceed 100 </br>");
      }

      if(this.Config.controls['EmailAccountTypeCode'].value !='GRAPHAPI'){
        if (this.Config.get('EmailPwd')?.errors?.required) {
          err.push("Please enter Password </br>");
        }

        if (this.Config.get('EmailPwd')?.errors?.maxLength) {
          err.push("Length of password should not exceed 25 </br>");
        }

        if (this.Config.get('SMTPHost')?.errors?.required) {
          err.push("Please enter SMTP Host Name  </br> ");
        }
    
        if (this.Config.get('SMTPPort')?.errors?.required) {
          err.push("Please enter SMTP Port Number  </br>");
        }
      }      

      if (this.Config.get('EmailAccountTypeCode')?.errors?.required || this.Config.get('EmailAccountTypeCode')?.value == "-1") {
        err.push("Please select Email Account type </br>");
      }
    }

    if (this.Config.get('EmailAccountTypeCode')?.errors == null) {
      let atVal = this.Config.get('EmailAccountTypeCode')?.value;
      if (atVal) {
        if (atVal === 'GOOGLE') {
          if (this.Config.get('GSuiteFileID')?.value == null && this.Config.get('EmailServerID')?.value == null && this.Config.get('TempFileID')?.value == null) {
            err.push("Please upload Google (G Suite/Gmail) file </br>");
          } else if (this.Config.get('GSuiteFileID')?.value == null && this.Config.get('EmailServerID')?.value != null && this.Config.get('TempFileID')?.value == null) {
            err.push("Please upload Google (G Suite/Gmail) file </br>");
          }
        }
        if (atVal === 'MICROSOFT'||atVal=== "GRAPHAPI") {
          if (this.Config.controls['MicrosoftTenantID'].value == "" || this.Config.controls['MicrosoftTenantID'].value == null ||  this.Config.controls['MicrosoftTenantID'].value == undefined) {
            err.push("Please enter Tenant ID </br>");
          }
          if (this.Config.controls['MicrosoftClientID'].value == "" || this.Config.controls['MicrosoftClientID'].value == null || this.Config.controls['MicrosoftClientID'].value == undefined) {
            err.push("Please enter Client ID </br>");
          }
          if (this.Config.controls["MicrosoftClientSecret"].value  == "" || this.Config.controls["MicrosoftClientSecret"].value == null || this.Config.controls["MicrosoftClientSecret"].value == undefined) {
            err.push("Please enter Client secret </br>");
          }
        }
      }
    }  
   
    if(this.Config.controls['EmailAccountTypeCode'].value =='GRAPHAPI'){
      if (this.Config.controls['MicrosoftTenantID'].value == "" || this.Config.controls['MicrosoftTenantID'].value == null ||  this.Config.controls['MicrosoftTenantID'].value == undefined) {
        err.push("Please enter Tenant ID </br>");
      }
      if (this.Config.controls['MicrosoftClientID'].value == "" || this.Config.controls['MicrosoftClientID'].value == null || this.Config.controls['MicrosoftClientID'].value == undefined) {
        err.push("Please enter Client ID </br>");
      }
      if (this.Config.controls["MicrosoftClientSecret"].value  == "" || this.Config.controls["MicrosoftClientSecret"].value == null || this.Config.controls["MicrosoftClientSecret"].value == undefined) {
        err.push("Please enter Client secret </br>");
      }

      if((this.Config.controls['GraphApiRead'].value == "" || this.Config.controls['GraphApiRead'].value == null ||  this.Config.controls['GraphApiRead'].value == undefined)&&
    (this.Config.controls['GraphApiSend'].value == "" || this.Config.controls['GraphApiSend'].value == null ||  this.Config.controls['GraphApiSend'].value == undefined)){
        err.push("Please select data in Graph API details to save the details");
      }
    }

    if (this.Config.get('IMAPHost')?.errors?.required && this.Config.get('IMAPPort')?.errors == null) {
      err.push("Please enter IMAP Host Name  </br> ");
    }

    if (this.Config.get('IMAPHost')?.errors == null && this.Config.get('IMAPPort')?.errors?.required) {
      err.push("Please enter IMAP Port Number </br>");
    }

    if(this.Config.controls['ManageAccessToken'].value){
      if (this.Config.controls['ManageUserEmailID'].value==""||this.Config.controls['ManageUserEmailID'].value==null||this.Config.controls['ManageUserEmailID'].value==undefined) {
        err.push("Please enter Manage User Email Address </br>");
      }

      let isValidEmail = this.commonservice.validateEmail(this.Config.controls['ManageUserEmailID'].value)
      if (!isValidEmail && this.Config.controls['ManageUserEmailID'].value) {
        err.push("Please enter valid Manage User Email Address </br>");
      }

      if (this.Config.controls['ManageUserEmailID']?.errors?.maxLength) {
        err.push("Length of Manage User Email Address should not exceed 100 </br>");
      }

      if (this.Config.controls['ManagerUserPassword'].value==""||this.Config.controls['ManagerUserPassword'].value==null||this.Config.controls['ManagerUserPassword'].value==undefined) {
        err.push("Please enter Manager User Password </br>");
      }

      if (this.Config.controls['ManagerUserPassword']?.errors?.maxLength) {
        err.push("Length of Manager User Password should not exceed 100 </br>");
      }
      if(!(this.Config.controls['ManageUserEmailID'].value== null||this.Config.controls['ManageUserEmailID'].value == undefined ||this.Config.controls['ManageUserEmailID'].value=="")&&!(this.Config.controls['EmailID'].value==null||this.Config.controls['EmailID'].value==undefined||this.Config.controls['EmailID'].value==""))
      {
        if(this.Config.controls['EmailID'].value==this.Config.controls['ManageUserEmailID'].value)
          {
            err.push("The Email Address and Manage user Email Address should be different. Please update details to save the configuration </br>");
          }
      }
    }


    if (err && err.length > 0) {
      let msg = err.join("");
      this.commonservice.ValidationBanner(msg);
      isValid = false;
    }
    //}

    return isValid;
  }

  cancel() {
    this.modalRef.close('yes');
  }

  dismissModal() {
    this.modalRef.close('yes');
  }

  typeChange(event:any) {
     
    if (event) {
      let  type = this.Config.get('EmailAccountTypeCode')?.value;
      if (type) {
         
          this.Config.get('MicrosoftTenantID')?.setValue(null);
          this.Config.get('MicrosoftClientID')?.setValue(null);
          this.Config.get('MicrosoftClientSecret')?.setValue(null);
          this.Config.get('ManageAccessToken')?.setValue(false);
        this.Config.get('ManageUserEmailID')?.setValue(null);
        this.Config.get('ManagerUserPassword')?.setValue(null);

          this.Config.controls['GSuiteFileID'].setValue(null);
          this.Config.get('TempFileID')?.setValue(null);
          this.Config.get('GSuiteFileID')?.setValue(null);
          this.Config.get('FileName')?.setValue(null);
          this.Config.get('FileExt')?.setValue(null);
          this.Config.get('FileBytes')?.setValue(null);

          this.fileName = "";
          this.Config.get('GraphApiRead').setValue(false);
          this.Config.get('GraphApiSend').setValue(false);

          if(type === "GRAPHAPI"){
            this.Config.get('SMTPHost').setValue(null);
            this.Config.get('SMTPPort').setValue(null);
            this.Config.get('IMAPHost').setValue(null);
            this.Config.get('IMAPPort').setValue(null);
          }

      }
    }
  }

  private validateFile() {

    let isValidFile = true;
    var err: any = [];
    let fileSize = 25;
    let fileType = this.fileToUpload?.name.substring(this.fileToUpload?.name.length - 4, this.fileToUpload.name.length);
    fileType = fileType?.toLowerCase();
    if (!(fileType === "json")) {
      isValidFile = false;
      err.push('The file type permitted to uploads is .json. Please select another file type to upload.');
    }
    if (this.fileToUpload != null && this.fileToUpload.size > (fileSize * 1048576)) {
      isValidFile = false;
      err.push(`Json size cannot be more than ${fileSize} MB`);
    }
    if (this.fileToUpload != null && this.fileToUpload.name != null && this.fileToUpload.name.length > 250) {
      isValidFile = false;
      err.push('File name cannot be more than 250 characters');
    }

    if (!isValidFile) {
      this.commonservice.ValidationBanner(err);

    }
    return isValidFile;
  }

  handleFile(event: any) {//:FileList) {
    let files = event?.target?.files;
    if (files.length > 0) {
      this.fileToUpload = files.item(0);
      let fileId: string | undefined;

      if (this.validateFile() && this.fileToUpload) {

        fileId = 'null'
        this.subUploadFile = this.smtpService.uploadFile(this.fileToUpload, fileId).subscribe(
          (result: FileData) => {

            this.Config.get('TempFileID')?.setValue(result.FileID);
            this.Config.get('FileName')?.setValue(result.FileName);
            this.Config.get('FileExt')?.setValue(result.FileExt);
            this.Config.get('FileBytes')?.setValue(result.FileBytes);
            this.handleFilePristine = true;
            if (result.FileName && result.FileExt)
              this.fileName = result.FileName + result.FileExt;
          },
          err => {
            this.commonservice.ValidationBanner(err);


          });
      }
    }
  }

  isSMTPValid() {
    return (this.Config.get('SMTPHost')?.valid && this.Config.get('SMTPPort')?.valid);
  }

  isIMAPValid() {
    return (this.Config.get('IMAPHost')?.valid && this.Config.get('IMAPPort')?.valid);
  }

  testSMTPConn() {

    if (this.validateSMTPTestForm()) {
      let modalRef = this.modalService.open(EmailtestconnectionComponent, {
        backdrop: false,
        keyboard: false,
        windowClass: 'modal-lg right modal-right',
        animation: true
      });
   modalRef.componentInstance.Content={
    heading: '',
    content: { Config: this.Config.value }
  }
      modalRef.result.then(result => {
        if (result == true) {
          this.isFormPristine = result;
          this.Config.controls['EmailServerStatus'].setValue(this.isFormPristine);
        }
      });
    }
  }

  validateSMTPTestForm() {
    let isValid = true;
     

    if (!this.Config.valid) {
      var err: any = [];
      if(this.Config.controls['EmailAccountTypeCode'].value =='GRAPHAPI' && this.Config.controls["GraphApiSend"].value== true){
        if (this.Config.controls['EmailID'].value==null||this.Config.controls['EmailID'].value==undefined||this.Config.controls['EmailID'].value=="") 
          {
          err.push("Please enter Email ID</br>");
         }
      }
      else if (this.Config.get('EmailID')?.errors?.required) {
        err.push("Please enter Email ID</br>");
      }
      else {
        if (!(this.Config.controls['EmailID'].value==null||this.Config.controls['EmailID'].value==undefined||this.Config.controls['EmailID'].value=="")){
          let isValidEmail = this.commonservice.validateEmail(this.Config.controls['EmailID'].value)
          if (!isValidEmail && this.Config.controls['EmailID'].value) {
            err.push("Please enter valid Email Address</br>");
          }
        }
      }
     if(this.Config.controls['ManageAccessToken'].value){
      if (this.Config.controls['ManageUserEmailID'].value==""||this.Config.controls['ManageUserEmailID'].value==null||this.Config.controls['ManageUserEmailID'].value==undefined) {
        err.push("Please enter Manage User Email Address </br>");
      }
     if (this.Config.controls['ManagerUserPassword'].value==""||this.Config.controls['ManagerUserPassword'].value==null||this.Config.controls['ManagerUserPassword'].value==undefined) {
      err.push("Please enter Manager User Password </br>");
    }
    if(!(this.Config.controls['ManagerUserPassword'].value==""||this.Config.controls['ManagerUserPassword'].value==null||this.Config.controls['ManagerUserPassword'].value==undefined)){
          if (this.Config.controls['ManagerUserPassword']?.errors?.maxLength) {
            err.push("Length of Manager User Password should not exceed 100 </br>");
          }
      }
      if (!(this.Config.controls['ManageUserEmailID'].value==null||this.Config.controls['ManageUserEmailID'].value==undefined||this.Config.controls['ManageUserEmailID'].value=="")){
        let isValidEmail = this.commonservice.validateEmail(this.Config.controls['ManageUserEmailID'].value)
        if (!isValidEmail && this.Config.controls['ManageUserEmailID'].value) {
          err.push("Please enter valid Manage User Email Address</br>");
        }
      }
  }
      if (this.Config.get('EmailID')?.errors?.maxLength) {
        err.push("Length of email id should not exceed 100 </br>");
      }
    if(this.Config.controls['EmailAccountTypeCode'].value !='GRAPHAPI'){
        if (this.Config.get('EmailPwd')?.errors?.required) {
          err.push("Please enter Password</br>");
        }
        }
    else if(!(this.Config.controls['EmailPwd'].value==null||this.Config.controls['EmailPwd'].value==undefined||this.Config.controls['EmailPwd'].value=="")){
          if (this.Config.get('EmailPwd')?.errors?.maxLength) {
            err.push("Length of Password should not exceed 25 </br>");
          }
      }
   
      if (this.Config.get('EmailAccountTypeCode')?.errors?.required || this.Config.get('EmailAccountTypeCode')?.value == null ||this.Config.get('EmailAccountTypeCode')?.value == "-1") {
        err.push("Please select Email Account type </br>");
      }
    }

    if (this.Config.get('EmailAccountTypeCode')?.errors == null) {
      let atVal = this.Config.get('EmailAccountTypeCode')?.value;
      if (atVal) {
        if (atVal === 'GOOGLE') {
          if (this.Config.get('GSuiteFileID')?.value == null && this.Config.get('EmailServerID')?.value == null && this.Config.get('TempFileID')?.value == null) {
            err.push("Please upload Google (G Suite/Gmail) file </br>");
          } else if (this.Config.get('GSuiteFileID')?.value == null && this.Config.get('EmailServerID')?.value != null && this.Config.get('TempFileID')?.value == null) {
            err.push("Please upload Google (G Suite/Gmail) file  </br>");
          }
        }
        if (atVal === 'MICROSOFT'||atVal=== "GRAPHAPI") {
          if (this.Config.controls['MicrosoftTenantID'].value == "" || this.Config.controls['MicrosoftTenantID'].value == null ||  this.Config.controls['MicrosoftTenantID'].value == undefined ) {
            err.push("Please enter Tenant ID </br>");
          }
          if (this.Config.controls['MicrosoftClientID'].value == "" || this.Config.controls['MicrosoftClientID'].value == null || this.Config.controls['MicrosoftClientID'].value == undefined) {
            err.push("Please enter Client ID </br>");
          }
          if (this.Config.controls["MicrosoftClientSecret"].value == "" || this.Config.controls["MicrosoftClientSecret"].value == null || this.Config.controls["MicrosoftClientSecret"].value == undefined) {
            err.push("Please enter Client secret </br>");
          }
        }
      }
    }
if(this.Config.controls['EmailAccountTypeCode'].value !='GRAPHAPI')
  {
    if (this.Config.get('SMTPHost')?.errors?.required) {
      err.push("Please enter SMTP Host Name </br>");
    }

    if (this.Config.get('SMTPPort')?.errors?.required) {
      err.push("Please enter SMTP Port Number </br>");
    }
  }
  

    if (err && err.length > 0) {
      let msg = err.join("");
      this.commonservice.ValidationBanner(msg);
      isValid = false;
    }

    return isValid;
  }

  testIMAPConn() {
    if (this.validateIMAPTestForm()) {
      this.Config.controls['ManageAccessToken'].setValue(this.Config.controls['ManageAccessToken'].value ==true?1:0);   
      this.subImapTestAsync = this.emailService.imapTestAsync(this.Config.value).subscribe(
        res => {
          if (res.Status == 0)
            this.commonservice.SuccessBanner(res.Message);
          else {
            if (res.Message)
              this.commonservice.ValidationBanner(res.Message);

          }
        },
        err => {
          this.commonservice.ValidationBanner(err);
        }
      );
    }
  }

  validateIMAPTestForm() {
    let isValid = true;

    if (!this.Config.valid) {
      var err: any = [];

      if (this.Config.get('EmailID')?.errors?.required) {
        err.push("Please enter Email Address </br>");
      }

      if (this.Config.get('EmailID')?.errors?.email) {
        err.push("Please enter valid Email Address </br>");
      }

      if (this.Config.get('EmailID')?.errors?.maxLength) {
        err.push("Length of Email Address should not exceed 100 </br>");
      }

      if (this.Config.get('EmailAccountTypeCode')?.value != "GRAPHAPI") {
        if (this.Config.get('EmailPwd')?.errors?.required) {
          err.push("Please enter password </br>");
        }

        if (this.Config.get('EmailPwd')?.errors?.maxLength) {
          err.push("Length of password should not exceed 25 </br>");
        }
      }

      if (this.Config.get('EmailAccountTypeCode')?.errors?.required || this.Config.get('EmailAccountTypeCode')?.value == null || this.Config.get('EmailAccountTypeCode')?.value == "-1") {
        err.push("Please select Email Account type </br>");
      }
    }

    if (this.Config.get('EmailAccountTypeCode')?.errors == null) {
      let atVal = this.Config.get('EmailAccountTypeCode')?.value;
      if (atVal) {
        if (atVal === 'GOOGLE') {
          if (this.Config.get('GSuiteFileID')?.value == null && this.Config.get('EmailServerID')?.value == null && this.Config.get('TempFileID')?.value == null) {
            err.push("Please upload Google (G Suite/Gmail) file </br>");
          } else if (this.Config.get('GSuiteFileID')?.value == null && this.Config.get('EmailServerID')?.value != null && this.Config.get('TempFileID')?.value == null) {
            err.push("Please upload Google (G Suite/Gmail) file  </br>");
          }
        }
        if (atVal === 'MICROSOFT' || atVal=== "GRAPHAPI") {
          if (this.Config.controls['MicrosoftTenantID'].value == "" || this.Config.controls['MicrosoftTenantID'].value == null ||  this.Config.controls['MicrosoftTenantID'].value == undefined) {
            err.push("Please enter Tenant ID </br>");
          }
          if (this.Config.controls['MicrosoftClientID'].value == "" || this.Config.controls['MicrosoftClientID'].value == null || this.Config.controls['MicrosoftClientID'].value == undefined) {
            err.push("Please enter Client ID </br>");
          }
          if (this.Config.controls["MicrosoftClientSecret"].value == "" || this.Config.controls["MicrosoftClientSecret"].value == null || this.Config.controls["MicrosoftClientSecret"].value == undefined) {
            err.push("Please enter Client secret </br>");
          }
        }
      }
    }

    if (this.Config.get('EmailAccountTypeCode')?.value != "GRAPHAPI") {
      if (this.Config.get('IMAPHost')?.errors?.required) {
        err.push("Please enter imap host name </br>");
      }

      if (this.Config.get('IMAPPort')?.errors?.required) {
        err.push("Please enter imap port number </br>");
      }
    }

    if (err && err.length > 0) {
      let msg = err.join("");
      this.commonservice.ValidationBanner(msg);

      isValid = false;
    }

    return isValid;
  }

  EnableEdit() {
    this.Content.content.OperationType = "Edit";
    this.Config.enable();
  }

  regexValidator(regex: RegExp, error: ValidationErrors): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      if (!control.value) {
        return null;
      }
      const valid = regex.test(control.value);
      return valid ? null : error;
    }
  }
  
  isReadValid(){
    return (this.Config.controls["GraphApiRead"].value && this.Config.get('GraphApiRead')?.valid);
  }

  isSendValid(){
    return (this.Config.controls["GraphApiSend"].value && this.Config.get('GraphApiSend')?.valid);
  }

  IsReadChecked(event){
    if(event==true){
      this.Config.controls["GraphApiRead"].value;
    }    
  }

  IsSendChecked(event){
    if(event==true){
      this.Config.controls["GraphApiSend"].value;
    }    
  }

  testGraphSendConn() {
    if (this.validateSMTPTestForm()){

    let modalRef = this.modalService.open(EmailtestconnectionComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-lg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content = {
      heading: '',
      content: { Config: this.Config.value, type: 'Graph' }
    }
    modalRef.result.then(result => {
      if (result == true) {
        this.isFormPristine = result;
        this.Config.controls['EmailServerStatus'].setValue(this.isFormPristine);
      }
    });  
  }  
  }

  testGraphReadConn() {
    if (this.validateIMAPTestForm()) {
      this.Config.controls['ManageAccessToken'].setValue(this.Config.controls['ManageAccessToken'].value ==true?1:0); 
      this.subImapTestAsync = this.emailService.graphReadTestAsync(this.Config.value).subscribe(
        res => {
          if (res.Status == 0)
            this.commonservice.SuccessBanner(res.Message);
          else {
            if (res.Message)              
              this.commonservice.ValidationBanner(res.Message);
          }
        },
        err => {
          this.commonservice.ValidationBanner(err);
        }
      );
    }
  }
}
